export interface CustomerExperienceAppointmentDashboardResponse {
    appointments: number;
    bookedToSatPercentage: number;
    satToInstructedPercentage: number;
    instructionValue: number;
    averageCaseSize: number;
    clearedAmount: number;
}

export function createCustomerExperienceAppointmentDashboardResponse(): CustomerExperienceAppointmentDashboardResponse {
    return {
        appointments: 0,
        bookedToSatPercentage: 0,
        satToInstructedPercentage: 0,
        instructionValue: 0,
        averageCaseSize: 0,
        clearedAmount: 0,
    };
}
